import { Location } from 'generated/graphql'

export const addressStringify = (location: Location) =>
  [
    [location.address, location.addressSecondary].filter(Boolean).join(' '),
    location.city,
    [location.state, location.zipCode].join(' '),
  ].join(', ')
